import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.map.js";
import "core-js/modules/esnext.iterator.reduce.js";
import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, unref as _unref, mergeProps as _mergeProps, withModifiers as _withModifiers, createVNode as _createVNode } from "vue";
import _imports_0 from '@/assets/img/empty.png';
const _hoisted_1 = {
  class: "table-box"
};
const _hoisted_2 = {
  key: 0,
  class: "extend-box"
};
const _hoisted_3 = {
  class: "vxe-table-box"
};
import { useAttrs } from 'vue';
import { ElMessage } from 'element-plus';
import { VxeTable } from 'vxe-table';
import { traverseTree } from '@/common/utils';

import { ref, computed, provide, nextTick, watch, onMounted } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    data: {},
    value: {},
    height: {
      default: 'auto'
    },
    hasImageColumn: {
      type: Boolean,
      default: false
    },
    hasExtend: {
      type: Boolean,
      default: false
    },
    checkedMethod: {
      type: Function,
      default: ({
        row
      }) => {
        return true;
      }
    },
    visibleMethod: {
      type: Function,
      default: ({
        row
      }) => {
        return true;
      }
    },
    inlineRules: {
      default: undefined
    },
    rowKey: {
      default: undefined
    },
    footerData: {}
  },
  emits: ["refresh", "update:value", "checkbox-select-change", "radio-select-change", "change"],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const attrs = useAttrs();
    // 定义事件
    const emit = __emit;
    // Props
    const props = __props;
    // 组件引用
    const table = ref();
    // form组件引用
    const inlineEditForm = ref();
    const inlineEditConfig = ref({
      // 编辑行数据
      rowData: undefined,
      // 编辑行数据备份
      rowCopy: undefined,
      // 编辑行数据是否发生变化
      isDirty: false,
      // 是否自动编辑下一行数据
      autoEditNext: false,
      // 下一行数据
      nextRow: undefined,
      // 是否新建
      isNew: false
    });
    // 变量
    let expandRows = [];
    const tableKey = new Date().getTime();
    const rowHeightStatus = ref('default');
    // computed属性，树型表格参数
    const treeConfig = computed(() => {
      const config = attrs['tree-config'];
      if (config && !config.toggleMethod) {
        config.toggleMethod = ({
          expanded,
          row
        }) => {
          if (treeRowKey.value) {
            let id = row[treeRowKey.value];
            if (id) {
              if (expanded) {
                if (expandRows.indexOf(id) === -1) expandRows.push(id);
              } else {
                expandRows = expandRows.filter(item => item !== id);
              }
            }
          }
          return true;
        };
      }
      return config;
    });
    const treeRowKey = computed(() => {
      return treeConfig.value ? treeConfig.value.rowField : undefined;
    });
    const rowHeightClass = computed(() => {
      const classArr = ['row-height-' + rowHeightStatus.value];
      if (props.hasImageColumn) {
        classArr.push('row-height-image');
      }
      return classArr;
    });
    // 方法
    const refresh = () => {
      emit('refresh');
    };
    provide('inlineEditConfig', inlineEditConfig.value);
    // 获取行内编辑信息
    const getInlineEditConfig = () => {
      return inlineEditConfig.value;
    };
    // 判断传入的行是否正在编辑状态
    const isRowEditing = row => {
      return inlineEditConfig.value.rowData === row;
    };
    // 判断表格是否正处于行内编辑状态
    const isTableEditing = () => {
      return inlineEditConfig.value.rowData != null;
    };
    // 清除行内组件校验结果
    const clearRowValidate = () => {
      if (inlineEditForm.value) {
        inlineEditForm.value.clearValidate();
      }
    };
    // 行内编辑组件校验
    const validateRowData = callback => {
      if (inlineEditForm.value && callback) {
        return inlineEditForm.value.validate(callback);
      }
    };
    // 编辑行数据
    const editRow = (row, isNew) => {
      if (row == null) return;
      if (inlineEditConfig.value.rowData != null && inlineEditConfig.value.isDirty) {
        ElMessage.warning('请先保存当前编辑的数据');
        return;
      }
      if (isNew) {
        // eslint-disable-next-line vue/no-mutating-props
        props.data.unshift(row);
      }
      inlineEditConfig.value.rowData = row;
      inlineEditConfig.value.rowCopy = {
        ...row
      };
      inlineEditConfig.value.isNew = isNew;
      nextTick(() => {
        inlineEditConfig.value.isDirty = false;
        clearRowValidate();
      });
    };
    // 保存行内编辑数据
    const saveRow = autoEditNext => {
      return new Promise((resolve, reject) => {
        if (inlineEditForm.value == null) {
          reject();
        } else {
          inlineEditForm.value.validate((valid, data) => {
            if (!valid) {
              // 表单校验失败
              let firstFaildColumn = null;
              if (data) {
                Object.keys(data).forEach((key, index) => {
                  let errorItem = data[key];
                  if (Array.isArray(errorItem) && errorItem.length > 0) {
                    if (index === 0) {
                      firstFaildColumn = key;
                    }
                    setTimeout(() => {
                      ElMessage.error(errorItem[0].message);
                    });
                  }
                });
              }
              reject(new Error(firstFaildColumn));
            } else {
              // 验证通过
              inlineEditConfig.value.autoEditNext = autoEditNext;
              if (inlineEditConfig.value.autoEditNext) {
                // 查找下一行数据
                let index = props.data.indexOf(inlineEditConfig.value.rowData);
                if (index !== -1 && index < props.data.length - 1) {
                  inlineEditConfig.value.nextRow = props.data[index + 1];
                }
              }
              let res = {
                rowData: inlineEditConfig.value.rowCopy,
                nextRow: inlineEditConfig.value.nextRow,
                isNew: inlineEditConfig.value.isNew,
                isDirty: inlineEditConfig.value.isDirty
              };
              inlineEditConfig.value.isDirty = false;
              resolve(res);
            }
          });
        }
      });
    };
    // 取消行内编辑
    const cancelEditRow = (deleteRow = true) => {
      inlineEditConfig.value.rowData = undefined;
      inlineEditConfig.value.rowCopy = undefined;
      inlineEditConfig.value.autoEditNext = false;
      inlineEditConfig.value.isDirty = false;
      inlineEditConfig.value.nextRow = undefined;
      if (inlineEditConfig.value.isNew && deleteRow) {
        // eslint-disable-next-line vue/no-mutating-props
        props.data.shift();
      }
    };
    const onRowHeightToogle = () => {
      if (rowHeightStatus.value == 'default') {
        rowHeightStatus.value = 'mini';
      } else {
        rowHeightStatus.value = 'default';
      }
    };
    const onSelectChange = (rows, multi) => {
      emit('update:value', rows);
      emit('change', rows, multi);
    };
    const onCheckBoxChange = ({
      checked
    }) => {
      let selectRows = [];
      if (table.value) {
        selectRows = table.value.getCheckboxRecords(true);
        selectRows = selectRows.concat(table.value.getCheckboxIndeterminateRecords(true));
      }
      onSelectChange(selectRows, true);
      emit('checkbox-select-change', selectRows);
    };
    const onCheckAllChange = ({
      checked
    }) => {
      let selectRows = [];
      if (table.value) {
        selectRows = table.value.getCheckboxRecords(true);
        selectRows = selectRows.concat(table.value.getCheckboxIndeterminateRecords(true));
      }
      onSelectChange(selectRows, true);
      emit('checkbox-select-change', selectRows);
    };
    const onRadioSelectChange = data => {
      let selectRow = null;
      if (table.value) {
        selectRow = table.value.getRadioRecord();
      }
      onSelectChange(selectRow != null ? [selectRow] : [], false);
      emit('radio-select-change', selectRow);
    };
    const setTableSelectRow = () => {
      nextTick(() => {
        if (table.value) {
          table.value.clearRadioRow();
          table.value.clearCheckboxRow();
          if (props.data == null) return;
          if (Array.isArray(props.value)) {
            // 多选
            table.value.setCheckboxRow(props.value, true);
          } else {
            // 单选
            table.value.setRadioRow(props.value);
          }
        }
      });
    };
    // 监听属性变化
    watch(() => props.value, () => {
      setTableSelectRow();
    }, {
      deep: true
    });
    watch(() => props.data, (newVal, oldValue) => {
      if (newVal == oldValue) return;
      if (treeRowKey.value) {
        let nodeList = [];
        traverseTree(props.data, node => nodeList.push(node), 'children');
        let defaultExpandRows = nodeList.filter(row => {
          if (!treeRowKey.value) {
            return false;
          }
          return expandRows.indexOf(row[treeRowKey.value]) != -1;
        });
        expandRows = defaultExpandRows.map(item => item[treeRowKey.value || 'id']);
        nextTick(() => {
          if (table.value) {
            table.value.setTreeExpand(defaultExpandRows, true);
          }
        });
      }
      let nextRow;
      if (inlineEditConfig.value.autoEditNext) {
        if (inlineEditConfig.value.isNew) {
          // 新建下一行数据
          let newRow = Object.keys(inlineEditConfig.value.rowCopy).reduce((acc, key) => {
            acc[key] = undefined;
            return acc;
          }, {});
          // eslint-disable-next-line vue/no-mutating-props
          props.data.unshift(newRow);
          nextRow = newRow;
        } else {
          if (inlineEditConfig.value.nextRow != null) {
            nextRow = (newVal || []).find(item => {
              if (props.rowKey == null) {
                return item === inlineEditConfig.value.nextRow;
              } else {
                return item[props.rowKey] === inlineEditConfig.value.nextRow[props.rowKey];
              }
            });
          }
          if (nextRow == null) {
            nextRow = (newVal || [])[0];
          }
        }
      }
      inlineEditConfig.value.rowData = nextRow;
      inlineEditConfig.value.rowCopy = nextRow ? {
        ...nextRow
      } : undefined;
      inlineEditConfig.value.nextRow = undefined;
      inlineEditConfig.value.autoEditNext = false;
    }, {
      immediate: true,
      deep: true
    });
    // 生命周期
    onMounted(() => {
      console.log('treeConfig', treeConfig);
    });
    const getTableImpl = () => {
      return table.value;
    };
    __expose({
      getTableImpl,
      getInlineEditConfig,
      isRowEditing,
      isTableEditing,
      clearRowValidate,
      validateRowData,
      editRow,
      saveRow,
      cancelEditRow
    });
    return (_ctx, _cache) => {
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_form = _resolveComponent("el-form");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_ctx.hasExtend || _ctx.$slots.operator ? (_openBlock(), _createBlock(_component_el_row, {
        key: 0,
        type: "flex",
        justify: "space-between",
        align: "middle",
        class: "operator-box"
      }, {
        default: _withCtx(() => [_createElementVNode("div", null, [_renderSlot(_ctx.$slots, "operator")]), _ctx.hasExtend ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("i", {
          class: "online-icon icon-custom-refresh",
          style: {
            "margin-right": "4px",
            "font-size": "20px",
            "color": "#333",
            "cursor": "pointer"
          },
          onClick: refresh
        }), _createElementVNode("i", {
          class: "online-icon icon-table-row-height",
          style: {
            "font-size": "20px",
            "color": "#333",
            "cursor": "pointer"
          },
          onClick: onRowHeightToogle
        })])) : _createCommentVNode("", true)]),
        _: 3
      })) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_form, {
        class: "inline-row-form",
        ref_key: "inlineEditForm",
        ref: inlineEditForm,
        model: _unref(inlineEditConfig).rowCopy,
        rules: props.inlineRules,
        "show-message": false,
        size: "small",
        "label-width": "0px",
        "label-position": "left",
        style: {
          "height": "100%"
        },
        onSubmit: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
      }, {
        default: _withCtx(() => [(_openBlock(), _createBlock(_unref(VxeTable), _mergeProps({
          "show-footer": true,
          ref_key: "table",
          ref: table,
          "show-overflow": "title",
          border: "inner",
          height: "100%",
          data: _ctx.data,
          class: _unref(rowHeightClass),
          key: _unref(tableKey)
        }, _ctx.$attrs, {
          "row-config": {
            ...(_ctx.$attrs.rowConfig || {}),
            isHover: true
          },
          "checkbox-config": {
            checkMethod: _ctx.checkedMethod,
            visibleMethod: _ctx.visibleMethod
          },
          "header-cell-class-name": "table-header-gray",
          onCheckboxChange: onCheckBoxChange,
          onCheckboxAll: onCheckAllChange,
          onRadioChange: onRadioSelectChange,
          "footer-data": _ctx.footerData
        }), {
          empty: _withCtx(() => _cache[1] || (_cache[1] = [_createElementVNode("div", {
            class: "table-empty unified-font"
          }, [_createElementVNode("img", {
            src: _imports_0
          }), _createElementVNode("span", null, "暂无数据")], -1)])),
          default: _withCtx(() => [_renderSlot(_ctx.$slots, "default")]),
          _: 3
        }, 16, ["data", "class", "row-config", "checkbox-config", "footer-data"]))]),
        _: 3
      }, 8, ["model", "rules"])]), _renderSlot(_ctx.$slots, "pagination", {
        class: "pagination-box"
      })]);
    };
  }
});